import Layout from '../../components/feature/Layout';
import Hero from './components/Hero';
import SafelineAiHubBanner from './components/SafelineAiHubBanner';
import FAQ from './components/FAQ';
import CTAServicios from './components/CTAServicios';
import LinkedInFeed from './components/LinkedInFeed';
import SEO from '../../components/feature/SEO';

const faqItems = [
  {
    question: '¿Qué tipo de empresas pueden trabajar con SafeLine?',
    answer:
      'Trabajamos con empresas contratistas, subcontratistas y organizaciones que operan en sectores como energía, construcción, mantenimiento industrial, logística, montaje y servicios técnicos que requieren cumplir exigencias documentales, operativas y preventivas.',
  },
  {
    question: '¿Qué incluye el servicio de gestión documental y acreditación?',
    answer:
      'Incluye revisión, orden y gestión documental de empresa, trabajadores y vehículos, control de vigencias, apoyo en plataformas de mandantes y acompañamiento para reducir observaciones, rechazos y retrasos operativos.',
  },
  {
    question: '¿Qué incluye una matriz de riesgos?',
    answer:
      'Incluye la identificación de peligros, evaluación de riesgos, definición de controles y estructuración del documento de acuerdo con la operación real de la empresa, para que sea útil tanto en terreno como en auditoría.',
  },
  {
    question: '¿Qué incluye una matriz de cumplimiento legal?',
    answer:
      'Incluye la identificación de normativa aplicable, organización de requisitos legales, estructura de control y base documental para facilitar el seguimiento del cumplimiento legal según la actividad y operación de cada empresa.',
  },
  {
    question: '¿SafeLine puede apoyar aunque no tengamos área HSE interna?',
    answer:
      'Sí. Podemos apoyar como soporte externo en tareas documentales, matrices, auditorías o gestión preventiva, adaptándonos al nivel de estructura y necesidad de cada empresa.',
  },
  {
    question: '¿El servicio puede ser remoto o presencial?',
    answer:
      'Sí. Dependiendo del servicio y la necesidad del cliente, el apoyo puede realizarse de forma remota, presencial o mixta, permitiendo adaptarnos a requerimientos documentales y también a necesidades operativas en terreno.',
  },
  {
    question: '¿Cómo se inicia el trabajo con SafeLine?',
    answer:
      'El trabajo comienza con una revisión breve de la necesidad del cliente. A partir de eso, se define el alcance, la modalidad de apoyo y la solución más adecuada según el tipo de operación, exigencia documental o requerimiento HSE.',
  },
];

const homeJsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'SafeLine Solutions',
    url: `${import.meta.env.VITE_SITE_URL ?? ''}`,
    logo: `${import.meta.env.VITE_SITE_URL ?? ''}/logo.png`,
    description:
      'Consultoría HSE corporativa, servicios en terreno, acreditación documental y capacitación en seguridad para empresas en Latinoamérica.',
    areaServed: 'Latinoamérica',
    serviceType: 'Consultoría HSE y Seguridad Corporativa',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      availableLanguage: 'Spanish',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'SafeLine Solutions',
    url: `${import.meta.env.VITE_SITE_URL ?? ''}`,
    description:
      'Soluciones HSE y seguridad corporativa para empresas en Latinoamérica.',
    inLanguage: 'es',
  },
  {
    '@context': 'https://schema.org',
    '@type': 'ProfessionalService',
    name: 'SafeLine Solutions',
    url: `${import.meta.env.VITE_SITE_URL ?? ''}`,
    description:
      'Consultoría HSE, auditorías de seguridad, gestión documental, asesoría en terreno, sistemas de gestión y capacitación preventiva en Latinoamérica.',
    areaServed: {
      '@type': 'Place',
      name: 'Latinoamérica',
    },
    hasOfferCatalog: {
      '@type': 'OfferCatalog',
      name: 'Servicios HSE',
      itemListElement: [
        {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: 'Gestión Documental HSE',
          },
        },
        {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: 'Auditorías HSE',
          },
        },
        {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: 'Asesoría en Terreno',
          },
        },
        {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: 'Sistemas de Gestión ISO',
          },
        },
        {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: 'Capacitación Preventiva',
          },
        },
      ],
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqItems.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  },
];

export default function HomePage() {
  return (
    <Layout transparentNav>
      
<SEO
  title="SafeLine Solutions - Consultoría HSE corporativa"
  description="SafeLine Solutions ofrece consultoría HSE corporativa, servicios en terreno, acreditación documental y capacitación en seguridad. Profesionales con vasta experiencia en Latinoamérica brindando soluciones técnicas y operativas para fortalecer la seguridad de tu empresa."
  keywords="consultoría HSE, seguridad corporativa, servicios en terreno, acreditación documental, capacitación preventiva, SafeLine Solutions"
  canonical="/"
  image="/og-cover.jpg"
  jsonLd={homeJsonLd}
/>


      <Hero />

      <SafelineAiHubBanner />

      <LinkedInFeed />

      <FAQ />

      <CTAServicios />
    </Layout>
  );
}